"use client";

import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";

type RevealDirection = "up" | "down" | "left" | "right";

type SectionRevealProps = {
	children: ReactNode;
	className?: string;
	delay?: number;
	duration?: number;
	distance?: number;
	direction?: RevealDirection;
	once?: boolean;
	amount?: number;
};

export default function SectionReveal({
	children,
	className,
	delay = 0,
	duration = 0.95,
	distance = 44,
	direction = "up",
	once = true,
	amount = 0.15,
}: SectionRevealProps) {
	const shouldReduceMotion = useReducedMotion();
	const x = direction === "left" ? distance : direction === "right" ? -distance : 0;
	const y = direction === "up" ? distance : direction === "down" ? -distance : 0;

	return (
		<motion.div
			className={className}
			initial={{
				opacity: 0,
				x: shouldReduceMotion ? 0 : x,
				y: shouldReduceMotion ? 0 : y,
				scale: shouldReduceMotion ? 1 : 0.985,
				filter: shouldReduceMotion ? "blur(0px)" : "blur(8px)",
			}}
			whileInView={{ opacity: 1, x: 0, y: 0, scale: 1, filter: "blur(0px)" }}
			viewport={{ once, amount }}
			transition={{ duration: shouldReduceMotion ? 0.25 : duration, delay, ease: [0.22, 1, 0.36, 1] }}
		>
			{children}
		</motion.div>
	);
}
